/**
 * External dependencies
 */
import inherits from 'inherits';

export default class CurrentCloudHosting {
    constructor(cscom) {
        if (!(this instanceof CurrentCloudHosting)) {
            return new CurrentCloudHosting(cscom);
        }
        this.cscom = cscom;
    }

    get(data) {
        return this.cscom.req.get('/customer-site-api/cloud-hosting/view', null, data);
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/cloud-hosting/list', null, data);
    }

}
